import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThunder: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="thunder,zap, flash"><path d="M16.4532 2.33297C17.048 0.559968 14.8014 -0.834145 13.5028 0.582963L3.46462 11.5371C2.43906 12.6563 3.21864 14.4841 4.7545 14.4841H9.58449C9.74862 14.4841 9.87912 14.6486 9.82429 14.8223L7.65434 21.6978C7.09393 23.4735 9.34492 24.8272 10.6246 23.4067L20.5464 12.3928C21.5577 11.2702 20.7752 9.45692 19.2464 9.45692H14.4165C14.2506 9.45692 14.1196 9.28888 14.1782 9.11419L16.4532 2.33297Z" fill="currentColor"/></CentralIconBase>;
};

export default IconThunder;
